import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "label", "eventLabel", "ariaLabel", "newTab", "className", "onClick"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isEmpty from 'lodash/isEmpty';
import { getValidProps } from '../../modules/foundation/services/props';
export function formatUriScheme(to) {
  if (to.startsWith('mailto://')) {
    return to.replace('mailto://', 'mailto:');
  }
  if (to.startsWith('tel://')) {
    return to.replace('tel://', 'tel:');
  }
  return to;
}
export function getOutboundLinkContainerProps(_ref) {
  var to = _ref.to,
    label = _ref.label,
    eventLabel = _ref.eventLabel,
    ariaLabel = _ref.ariaLabel,
    newTab = _ref.newTab,
    className = _ref.className,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var validProps = ['href', 'target', 'rel', 'tittle', 'download', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'aria-label', 'aria-labelledby', 'aria-selected', 'aria-expanded', 'aria-checked', 'aria-busy', 'style', 'id', 'ref', 'role'];
  var validRestProps = getValidProps(rest, validProps);
  var linkProps = newTab ? {
    href: to,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {
    href: to
  };
  var options = _objectSpread(_objectSpread(_objectSpread({}, linkProps), validRestProps), {}, {
    onClick: onClick
  });
  if (!_isEmpty(className)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      className: className
    });
  }
  var finalAriaLabel = ariaLabel || label || eventLabel || '';
  if (!_isEmpty(finalAriaLabel)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      'aria-label': finalAriaLabel
    });
  }
  return options;
}